module.exports = __webpack_public_path__ + "static/img/MITCHELL_MARSH.4939ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MITCHELL_MARSH.jpg
// module id = sbOy
// module chunks = 0